/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Output_Language_LabelInputs */



/**
* | output |
* | --- |
* | "Output Language" |
*
* @param {Ad_Output_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_output_language_label = /** @type {((inputs?: Ad_Output_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Output_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabesprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Язык вывода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idioma de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Idioma de saída")
	return /** @type {LocalizedString} */ ("Output Language")
});